import React from 'react';

export function ItemHeadMarket() {

  return (
    <>
              <thead>
                <tr className='market-item__header'>
                          <th>Date</th>
                          <th>Market</th>
                          <th>Network</th>
                          <th>Membership</th>
                          <th>Address</th>
                          <th>Accions</th>
                  </tr>
              </thead>
         
    </>
  )
}
